export default {
    contact_type: {
        registrant: 'Registrant Contacts',
        tech: 'ទំនាក់ទំនងបច្ចេកទេស',
        admin: 'ទំនាក់ទំនងអ្នកគ្រប់គ្រង',
        auxBilling: 'ទំនាក់ទំនងការចេញវិក្កយប័ត្រ',
    },
};
